import { IQuestionModel } from '@care-portals/api-interfaces';

const caProvinces = [
  { code: 'ON', province: 'Ontario' },
  //{ code: 'QC', province: 'Quebec' },
  { code: 'AB', province: 'Alberta' },
  { code: 'BC', province: 'British Columbia' },
  { code: 'MB', province: 'Manitoba' },
  { code: 'NL', province: 'Newfoundland and Labrador' },
  // { code: 'PE', province: 'Prince Edward Island' },
 // { code: 'NS', province: 'Nova Scotia' },
  { code: 'NB', province: 'New Brunswick' },
  { code: 'SK', province: 'Saskatchewan' },
  { code: 'YT', province: 'Yukon Territory' },
  { code: 'NT', province: 'Northwest Territories' },
  { code: 'NU', province: 'Nunavut' }
];

const questionsModels: IQuestionModel[] = [
  /**
   * Health Card Form
   */
  {
    label: 'Please choose your province.',
    field: 'rda50Province',
    type: 'info',
    answer: {
      type: 'dropdown',
      name: 'province',
      placeholder: 'Please select',
      options: caProvinces.map(item => ({
        key: item.code,
        value: item.province
      }))
    }
  }
];

export default questionsModels;
